// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".service-mesh-list-tag-red-font-color-3f2bc{color:var(--color-error-6)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag-red-font-color": "service-mesh-list-tag-red-font-color-3f2bc",
	"tagRedFontColor": "service-mesh-list-tag-red-font-color-3f2bc"
};
export default ___CSS_LOADER_EXPORT___;
